import {
  RECEIVE_CONTEST_ITEMS,
  REQUEST_CONTEST_ITEMS,
  TOGGLE_ACTIVE_CONTEST_POPUP,
  SET_ACTIVE_CONTEST_POPUP,
  SET_CONTEST_MODE,
  SET_SIGNUP_FLOW,
  SET_CONTEST_STEP,
  CLEAR_CONTEST_SUBMITTED_ERROR,
  RECEIVE_CONTEST_SUBMITTED_ERROR,
  TOGGLE_ACTIVE_AUTH_POPUP,
  CONTEST_HAS_SUBMITTED
} from '../constants/actionTypes';

const INITIAL_STATE = {
  loading: true,
  contestItems: [],
  hasVoted: false,
  isLoggedIn: false,

  hasSubmitted: false, // for API submitContest once success
  submissionError: false,
  error: false,

  showPopup: false,
  activeContestId: null, // for contest popup
  activeContestItem: null, // for contest popup
  step: 'voting', // 'voting', 'voted', 'submission', 'done', 'alreadyVoted'

  showAuthPopup: false,
  signupFlow: false, // 'signup', 'login', 'verify', 'resetPassword'
  contestMode: false // trigger header login/signup to open popup instead
};

function contestReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUEST_CONTEST_ITEMS: {
      return {
        ...state,
        loading: true
      };
    }
    case RECEIVE_CONTEST_ITEMS: {
      return {
        ...state,
        contestItems: action.data.trips,
        hasVoted: action.data.has_voted,
        isLoggedIn: action.data.is_logged_in,
        loading: false
      };
    }
    case CONTEST_HAS_SUBMITTED: {
      return {
        ...state,
        hasSubmitted: action.hasSubmitted
      };
    }
    case CLEAR_CONTEST_SUBMITTED_ERROR: {
      return {
        ...state,
        submissionError: false
      };
    }
    case RECEIVE_CONTEST_SUBMITTED_ERROR: {
      return {
        ...state,
        submissionError: action.submissionError
      };
    }
    case TOGGLE_ACTIVE_CONTEST_POPUP: {
      return {
        ...state,
        showPopup: action.show
      };
    }
    case TOGGLE_ACTIVE_AUTH_POPUP: {
      return {
        ...state,
        showAuthPopup: action.show
      };
    }
    case SET_ACTIVE_CONTEST_POPUP: {
      return {
        ...state,
        activeContestId: action.id
      };
    }
    case SET_CONTEST_MODE: {
      return {
        ...state,
        contestMode: action.status
      };
    }
    case SET_SIGNUP_FLOW: {
      return {
        ...state,
        signupFlow: action.flow
      };
    }
    case SET_CONTEST_STEP: {
      return {
        ...state,
        step: action.step
      };
    }

    default:
      return state;
  }
}

export default contestReducer;
